const STORAGE_KEY = 'gitlab_urls_history';
const MAX_URLS = 10;

export const getGitlabSavedUrls = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : [];
  } catch (e) {
    return [];
  }
};

export const saveGitlabUrl = (url) => {
  try {
    if (!url || url.trim() === '') return;
    const saved = getGitlabSavedUrls();
    const filtered = saved.filter(u => u !== url);
    localStorage.setItem(STORAGE_KEY, JSON.stringify([url, ...filtered].slice(0, MAX_URLS)));
  } catch (e) {}
};

export const removeGitlabUrl = (url) => {
  try {
    const saved = getGitlabSavedUrls();
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved.filter(u => u !== url)));
  } catch (e) {}
};
